<template>
	<button type="button" class="btn btn-sm rounded-pill ps-3 px-2 fw-bold" :class="[info.class, (selected) ? 'border-dark' : null]" @click="select" v-if="info">{{ info.title }}<span class="badge rounded-pill ms-2 bg-white text-dark">{{ count.total }}</span></button>
	<button type="button" class="btn btn-sm rounded-pill ps-3 px-2 fw-bold bg-gray-200" :class="[(selected) ? 'border-dark' : null]" @click="select" v-else>{{ info.title }}<span class="badge rounded-pill ms-2 bg-white text-dark">{{ count.total }}</span></button>
</template>

<script>
	import { computed, inject } from 'vue';

	export default {
		props: {
			count: Object,
			selected: Boolean
		},
		setup(props, { emit }) {
			const $env = inject('$env');

			const info = computed(() => {
				if(props.count.status in $env.MODEL.CustomerUser.statuses) return $env.MODEL.CustomerUser.statuses[props.count.status];
				else return null;
			});

			const select = () => emit('select', props.count.status);

			return { info, select };
		}
	}
</script>